import config from '../config'
import {
  OrderFilter,
  OrderHistory,
  OrderHistoryRefundRequest,
  PaginatedResult,
} from '../pages/order-histories-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config
const baseUrl = `${mainApi}/order-histories`

export const getOrderHistories = (params: OrderFilter) =>
  authRequest.get<MISSING_TYPE, PaginatedResult<OrderHistory>>(baseUrl, { params })

export const getOrderHistory = (id: number) =>
  authRequest.get<MISSING_TYPE, OrderHistory>(`${baseUrl}/${id}`)

export const refundOrder = (id: number) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/refund`)

export const partiallyRefundOrder = (id: number, data: OrderHistoryRefundRequest) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/partial-refund`, data)

export const markOrderManualRefundPending = (id: number) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/manual-pending`)

export const manuallyRefundOrder = (id: number, data: OrderHistoryRefundRequest) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/manual-refund`, data)

export const refreshRefundStatus = (id: number) =>
  authRequest.post<MISSING_TYPE, void>(`${baseUrl}/${id}/refresh-refund`)
